<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    import themeConfig from '@/../themeConfig.js';
    import validate_pt from 'vee-validate/dist/locale/pt_BR';
    import {mapActions, mapGetters} from "vuex";

    export default {
        watch: {
            '$store.state.theme'(val) {
                this.toggleClassInBody(val);
            }
        },
        computed: {
            ...mapGetters(["idUser", "authToken"])
        },
        methods: {
            ...mapActions(['logout']),
            toggleClassInBody(className) {
                if (className === 'dark') {
                    if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
                    document.body.classList.add('theme-dark');
                } else if (className === 'semi-dark') {
                    if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                    document.body.classList.add('theme-semi-dark');
                } else {
                    if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
                    if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
                }
            }
        },
        async created() {
            this.$validator.localize('pt_BR', validate_pt);

            if (this.authToken) {
                this.$axios.interceptors.request.use(config => {
                    config.headers['Authorization'] = `Bearer ${this.authToken}`;
                    return config;
                });
            }

            this.$axios.interceptors.response.use(
                config => config,
                async error => {
                    if (error.response) {
                        let message = error.response.data.message || "";

                        /**
                         * Erro de autenticação
                         */
                        if (error.response.status === 401) {
                            error.config.headers.Authorization = null;
                            await this.logout();
                            this.$router.push({name: 'login'});
                            message = 'Erro de autenticação';
                        }

                        /**
                         * Erro de validação
                         */
                        if (error.response.status === 422) {
                            return Promise.reject(error);
                        }

                        /**
                         * Demais erros
                         */
                        if (error.response.data.error) {
                            message = error.response.data.error;
                        }

                        return Promise.reject({message});
                    }
                    return Promise.reject(error);
                });
            /**
             * Esta condição se o usuário está conectado, pois acessa o middleware de autenticação do servidor
             */
            if (this.idUser) {
                await this.$axios.get('/auth/ping');
            }
        },
        mounted() {
            this.toggleClassInBody(themeConfig.theme)
        }
    }
</script>
